module.exports = __webpack_public_path__ + "img/cappuccino-thumb.6417f765.png";